export default function getRightValue(newValue: any, oldValue: any) {
  return !newValue && newValue !== 0 ? oldValue : newValue;
}
